export default "__VITE_ASSET__DY27wF0j__"